import { useSelector } from 'react-redux'
import { PmiStatus } from '../../../../../types/pmi'
import { useIntl, defineMessages } from 'react-intl'
import { RootState } from '../../../../../types/rootState'
import { EQUITY_FOR_PMI_REMOVAL, SOON } from '../../pmiConstants'
import { Box, Text, Heading } from '@homebotapp/hb-react-component-catalog'
import { PmiProvidedModuleLearnMoreButton } from '../../PmiProvidedModuleLearnMoreButton'

export const MSG = defineMessages({
  keepOn: {
    id: 'PMI.pmiDetailsText.keepOnTrack',
    defaultMessage: 'Keep on track'
  },
  almost: {
    id: 'PMI.pmiDetailsText.almostThere',
    defaultMessage: 'Almost there'
  },
  goal: {
    id: 'PMI.pmiDetailsText.goalEquity',
    defaultMessage: 'The goal is usually {goal}% equity'
  },
  remove: {
    id: 'PMI.pmiDetailsText.cannotRemove',
    defaultMessage: 'You might be able to remove PMI with {goal} equity.'
  },
  estimate: {
    id: 'PMI.pmiDetailsText.estimatedEquity',
    defaultMessage: 'Based on your estimated home value and principal paid, we estimate you have {current} equity.'
  }
})

export interface CannotRemovePmiDetailsProps {
  ltcvPercent: number
}

export const CannotRemovePmiDetails = ({ ltcvPercent }: CannotRemovePmiDetailsProps) => {
  const intl = useIntl()
  const status = useSelector<RootState, PmiStatus | null>(state => state.pmi.status)

  return (
    <Box
      mt='16'
      mb='12'
      ml='auto'
      mr='auto'
      paddingX='8'
      paddingY='6'
      maxWidth='28rem'
      borderRadius='.75rem'
      // @ts-ignore
      backgroundColor='var(--brand-surface-layer-50)'
    >
      <Heading as='h4' size='xs' variant='eyebrow' color='neutral-700'>
        {intl.formatMessage(status === SOON ? MSG.almost : MSG.keepOn)}
      </Heading>
      <Heading as='h3' textAlign='left' fontWeight='semibold'>
        {intl.formatMessage(MSG.goal, { goal: EQUITY_FOR_PMI_REMOVAL })}
      </Heading>
      <Text size='sm' marginY='4'>
        {intl.formatMessage(MSG.remove, {
          goal: (
            <Text as='span' size='sm' color='neutral-900' fontWeight='bold'>
              {EQUITY_FOR_PMI_REMOVAL}%
            </Text>
          )
        })}
      </Text>
      <Text size='sm' marginBottom='4'>
        {intl.formatMessage(MSG.estimate, {
          current: (
            <Text as='span' size='sm' color='neutral-900' fontWeight='bold'>
              {Math.floor(100 - ltcvPercent)}%
            </Text>
          )
        })}
      </Text>
      <PmiProvidedModuleLearnMoreButton />
    </Box>
  )
}
